export default "__VITE_ASSET__D4Hrmw83__"